<rms-mod height="auto" width="100%">
  @if (loading) { <div role="status" class="load-state">Loading SKU pricingâ€¦</div> }
  @if (loadError) { <div role="alert" class="load-state">{{loadError}} <button mat-button class="btn-bg-blue" (click)="ngOnInit()">Retry</button></div> }
  <div class="pricing-top">
    <fieldset class="rms-fieldset pricing-filters">
      <legend>Filters</legend>

      <div class="filter-container">
        <div class="filter-row">
          <div style="display:flex; flex-direction:column; gap:5px;">


            <div class="filter-row">
              <rms-radio [options]="customGroupOptions"
                         [(ngModel)]="CustomGroupFilter"
                         label="Filter Type"
                         [flexRow]="true"
                         (ngModelChange)="onChangeCustomGroupFilter()">
              </rms-radio>
              @if (CustomGroupFilter === 'Custom') {
              <rms-select [options]="CustomGroups"
                          label="Custom Group"
                          labelKey="CustomGroupFilterName"
                          valueKey="CustomGroupFilterID"
                          [(ngModel)]="SelectedCustomGroupID"
                          (ngModelChange)="onChangeCustomGroup()">
              </rms-select>

              <button mat-button
                      class="btn-bg-yellow"
                      (click)="ViewCustomFilters()">
                View Custom Filters
              </button>

              <button mat-button
                      class="btn-bg-red"
                      (click)="ClearSearch()">
                <mat-icon>close</mat-icon>
                Clear Filter
              </button>
              }
              @else {
              <rms-select [options]="Regions"
                          label="Region"
                          labelKey="RegionName"
                          valueKey="RegionId"
                          [(ngModel)]="RegionID"
                          (ngModelChange)="onChangeRegion()">
              </rms-select>

              <rms-select [options]="filteredCountries"
                          label="Country"
                          labelKey="CountryName"
                          valueKey="CountryID"
                          [(ngModel)]="CountryID"
                          (ngModelChange)="onChangeCountry()"
                          [disabled]="!RegionID">
              </rms-select>

              <rms-select [options]="filteredGroups"
                          label="Groups"
                          labelKey="GroupName"
                          valueKey="GroupID"
                          [(ngModel)]="GroupID"
                          [disabled]="!CountryID"
                          (ngModelChange)="onChangeGroup()">
              </rms-select>

              <button mat-button
                      class="btn-bg-red"
                      (click)="ClearSearch()">
                <mat-icon>close</mat-icon>
                Clear Filter
              </button>
              }
            </div>
          </div>
        </div>
      </div>
    </fieldset>
    <div class="pricing-basis">
      <div class="basis-panel">
        <div class="basis-header">
          <mat-icon>trending_up</mat-icon>
          Current Futures Basis
        </div>

        <div class="basis-cards">

          <div class="basis-card nyc">
            <div class="basis-label">
              NYC
            </div>

            <div class="basis-value">
              {{ CurrentNYCBasis | currency }}
            </div>

            <div class="basis-subtitle">
              Arabica
            </div>
          </div>

          <div class="basis-card ldn">
            <div class="basis-label">
              LDN
            </div>

            <div class="basis-value">
              {{ CurrentLDNBasis | currency }}
            </div>

            <div class="basis-subtitle">
              Robusta
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div>
    <fieldset class="rms-fieldset">
      <legend>{{SelectedCustomGroup ? SelectedCustomGroup.CustomGroupFilterName : (SelectedGroup ? SelectedGroup.GroupName : 'SKUs')}}</legend>

      <div class="pricing-results">
        <div class="table-filter">
          <div class="pricing-view-tabs" role="group" aria-label="SKU view"><button mat-button [class.active]="needsUpdateOnly" (click)="needsUpdateOnly=true; buildFilteredSKUs()">SKUs needing update</button><button mat-button [class.active]="!needsUpdateOnly" (click)="needsUpdateOnly=false; buildFilteredSKUs()">SKU summary</button></div>
          <rms-select label="Futures month" [options]="futuresMonthOptions" labelKey="name" valueKey="name" [(ngModel)]="FuturesMonth" (ngModelChange)="buildFilteredSKUs()"></rms-select>
        </div>
        <div class="pricing-table">
          <rms-table #pricingTable [data]="filteredSKUs"
                     [columns]="skuPricingColumns"
                     [IncludeSearch]="true"
                     [IncludeSort]="true"
                     startSort="InventoryTypeName"
                     startSortDirection="asc"
                     [icons]="SkuIcons"
                     [footerButtons]="SelectedRows ? FooterButtons : []">
          </rms-table>
        </div>
        <div class="pricing-summary">
          <div class="summary-card">
            <div class="summary-label">SKUs</div>
            <div class="summary-value">
              {{ Summary.SKUCount }}
            </div>
          </div>

          <div class="summary-card spot">
            <div class="summary-label">Spot Bags</div>
            <div class="summary-value">
              {{ Summary.TotalSpotBags | number:'1.0-0' }}
            </div>
          </div>

          <div class="summary-card forward">
            <div class="summary-label">Forward Bags</div>
            <div class="summary-value">
              {{ Summary.TotalForwardBags | number:'1.0-0' }}
            </div>
          </div>

          <div class="summary-card spot">
            <div class="summary-label">Average Spot Cost / Diff</div>
            <div class="summary-value">
              {{ Summary.AverageSpotDisplay }}
            </div>
          </div>

          <div class="summary-card forward">
            <div class="summary-label">Average Forward Cost / Diff</div>
            <div class="summary-value">
              {{ Summary.AverageForwardDisplay }}
            </div>
          </div>

          <div class="summary-card replacement">
            <div class="summary-label">Average Replacement Fixed</div>
            <div class="summary-value">
              {{ Summary.AverageReplacementFixed | currency }}
            </div>
          </div>

          <div class="summary-card market">
            <div class="summary-label">'C' Market Avg</div>
            <div class="summary-value">
              {{ Summary.AverageMarketPrice | currency }}
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</rms-mod>
